<template>
  <div class="card no-body">
    <div class="card-header d-flex">
        <h3 class="h3 mb-0">Workspace Users</h3>
      <invite-user-modal v-if="loaded && mayInvite" :assignableRoles="inviteOptions"></invite-user-modal>
      <div class="ml-auto p-1">
        <b-input-group size="sm">
          <b-form-input
            v-model="searchValue"
            type="search"
            placeholder="Search"
          ></b-form-input>
        </b-input-group>
      </div>

    </div>

    <div v-if="loaded">
        <div v-if="hasUsers">
            <b-list-group flush class="account-user-list-group">
                <workspace-users-list-item v-for="user in filterUsers()" :key="user.user.userId" :user="user" :allRoles="rootWrapper.accountRolesList" @remove-account-user="removeUser"></workspace-users-list-item>
            </b-list-group>
        </div>
        <div v-else class="text-center p-3">
            <div> No other users are associated with this workspace. </div>
        </div>
    </div>
    <div v-else class="text-center p-3">
        <b-spinner size="sm"></b-spinner>
    </div>
    <div class="card-footer d-flex">
      <b-form-invalid-feedback :state="!errorMessage" class="text-center">
          {{errorMessage}}
      </b-form-invalid-feedback>
      <b-button v-if="loaded && mayInvite" size="sm" variant="outline-primary" class="ml-auto" v-b-modal.invite-user-modal>Invite</b-button>
    </div>
  </div>
</template>
<script>
import { AccountUserListRequest, RoleRemoveUserRequest } from '#/protobuf/service_account_pb';

import InviteUserModal from '#/ui/Components/InviteUserModal.vue';
import WorkspaceUsersListItem from '#/ui/Components/Workspace/WorkspaceUsersListItem.vue';

export default {
  components: {
    InviteUserModal,
    WorkspaceUsersListItem,
  },
  props: {
    // rootWrapper: {
    //   type: Object, // corresponds to an AccountUserListResponse
    //   required: true,
    // },
  },
  data() {
    return {
      rootWrapper: undefined,
      loaded: false,
      inviteOptions: undefined,
      searchValue: '',
      errorMessage: undefined,
    };
  },
  created() {
    this.loadAccountRoles().then(() => {
      this.inviteOptions = this.rootWrapper.accountRolesList.map((role) => ({
        value: role.roleId,
        text: role.details.name,
        disabled: role.roleId === 0 || !this.rootWrapper.newUserAllowedRolesList.includes(role.roleId),
      }));
      this.loaded = true;
    });
  },
  computed: {
    hasUsers() {
      return this.rootWrapper.usersList && this.rootWrapper.usersList.length > 0;
    },
    mayInvite() {
      return this.rootWrapper.newUserAllowedRolesList.length > 0;
    },
    users() {
      return this.rootWrapper.usersList;
    },
  },
  methods: {
    filterUsers() {
      // eslint-disable-next-line max-len
      return this.rootWrapper.usersList.filter((user) => (`${user.user.userFirstName} ${user.user.userLastName} ${user.user.userNickname} `).toLowerCase().match(new RegExp(this.searchValue.trim().toLowerCase(), 'g')));
    },
    async loadAccountRoles() {
      const request = new AccountUserListRequest();
      return this.$store.dispatch('accounts/loadAccountUsers', request).then((data) => {
        this.rootWrapper = data;
        this.inviteOptions = this.rootWrapper.accountRolesList.map((role) => ({
          value: role.roleId,
          text: role.details.name,
          disabled: role.roleId === 0 || !this.rootWrapper.newUserAllowedRolesList.includes(role.roleId),
        }));
      }).catch((error) => {
        console.warn('error loadAccountRoles: ', error);
        this.errorMessage = `Error in loading account users. ${error}`;
      }).finally(() => {
        this.loaded = true;
      });
    },
    removeUser(userId) {
      console.info('removing user...', userId);
      const request = new RoleRemoveUserRequest();
      request.setUserId(userId);
      request.setRemoveFromAccount(true);
      return this.$store.dispatch('accounts/removeUserRole', request).then((response) => {
        console.log('RESPONSE removeUserRole', response);
        const index = this.rootWrapper.usersList.findIndex((user) => user.user.userId === userId);
        console.log('INDEX', index, this.rootWrapper.usersList);
        if (index) {
          this.rootWrapper.usersList.splice(index, 1);
        }
        // this.$nextTick(() => {
        //   this.email = '';
        //   // this.$bvModal.hide('invite-user-modal');
        // });
      }).catch((error) => {
        console.log('removeUserRole error', error.message);
        // this.invalidText = error.message;
        this.errorMessage = `Error in removing user role. ${error.message}`;
      });
    },
  },
};
</script>
<style>
</style>
